import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsThisForSection() {
  return <section className="py-20 bg-[#0a0a0a]" data-id="element-178">
      <div className="max-w-6xl mx-auto px-4" data-id="element-179">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-180">
          {/* Left Column - FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] p-8 rounded-2xl border-t-4 border-green-500" data-id="element-181">
            <h3 className="text-2xl font-black text-white mb-8 uppercase flex items-center gap-3" data-id="element-182">
              <span className="bg-green-500/20 p-2 rounded-lg text-green-500" data-id="element-183">
                <Check className="w-6 h-6" data-id="element-184" />
              </span>
              Este libro ES para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {['Querés consistencia como ADC', 'Querés entender el rol en profundidad', 'Querés mejorar decisiones, no solo mecánicas', 'Estás cansado de perder partidas que deberías ganar'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-186">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span data-id="element-188">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - NOT FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] p-8 rounded-2xl border-t-4 border-red-500" data-id="element-189">
            <h3 className="text-2xl font-black text-white mb-8 uppercase flex items-center gap-3" data-id="element-190">
              <span className="bg-red-500/20 p-2 rounded-lg text-red-500" data-id="element-191">
                <X className="w-6 h-6" data-id="element-192" />
              </span>
              Este libro NO es para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-193">
              {['Buscás atajos o builds milagrosas', 'Jugás casual y no querés pensar', 'Buscás tutoriales básicos para principiantes', 'No estás dispuesto a cambiar tu forma de jugar'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-194">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-195" />
                  <span data-id="element-196">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}